import React from "react"
import { Route, Redirect, Switch, useHistory, useRouteMatch, useLocation } from "react-router-dom"
import useSWR from "swr"
import { Lang } from "./const"
import { useGlobalContext } from "./context"
import { fetchJSON } from "./functions"
// components
import Main from "./components/Main"
import { Login, ResetPassword } from "./components/Login"
import Paypal from "./components/Paypal"
import SignUp from "./components/SignUp"
import IrPayment from "./components/IrPayment"

const AdminRoutes = React.lazy(() => import("./components/AdminRoutes"))
const UserRoutes = React.lazy(() => import("./components/UserRoutes"))
// first detect the lang
const RoutesMatch = () => {
    const { globalState, dispatch } = useGlobalContext()
    return (
        <Switch>
            <Route path="/:urlLang(en|fa)" render={(props) => <Routes lang={props.match.params.urlLang as Lang} />} />
            <Route path="/" exact render={(props) => <Redirect to={`/${globalState.lang}`} {...props} />} />
            <Route
                render={(props) => {
                    return <h1>404</h1>
                }}
            />
        </Switch>
    )
}

const Routes = ({ lang }: { lang: Lang }) => {
    const { globalState, dispatch } = useGlobalContext()
    const { data } = useSWR(`/lang/${lang}.json`, fetchJSON)

    const history = useHistory()
    const RouteMatch = useRouteMatch()
    const { pathname } = useLocation()

    React.useEffect(() => {
        if (lang !== globalState.lang && !globalState.authorized) dispatch({ type: "set-lang", payload: lang })
    }, [lang, globalState.lang, globalState.authorized])
    React.useEffect(() => {
        if (globalState.lang !== lang && globalState.authorized && !/\/login|signup/gi.test(pathname)) {
            // console.log("%c!", "color:white;padding:.5em;background-color: red;", history, RouteMatch, pathname)
            history.push(pathname.replace(`/${lang}/`, `/${globalState.lang}/`))
        }
    }, [globalState.lang, lang, globalState.authorized])
    React.useEffect(() => {
        globalState.lang === "fa" ? (document.body.dir = "rtl") : (document.body.dir = "ltr")
    }, [globalState.lang])
    React.useEffect(() => {
        data && dispatch({ type: "set-w", payload: data })
    }, [data])

    React.useEffect(() => {
        dispatch({ type: "set-urls", payload: pathname })
    }, [pathname])

    return (
        <Main lang={lang}>
            <Switch>
                <Route path={`/${lang}/admin`} exact component={AdminRoutes} />
                <Route path={`/${lang}/user`} component={UserRoutes} />
                <Route path={`/${lang}/login`} exact component={Login} />
                <Route path={`/${lang}/reset_password`} exact component={ResetPassword} />
                <Route path={`/${lang}/paypal`} exact component={Paypal} />
                <Route path={`/${lang}/signup`} exact component={SignUp} />
                <Route path={`/${lang}/ir-payment`} exact component={IrPayment} />

                <Route path={`/${lang}`} exact render={(props) => <Redirect to={`/${lang}/login`} {...props} />} />
                <Route render={(props) => <Redirect to={`/${globalState.lang}/login`} />} />
            </Switch>
        </Main>
    )
}

export default RoutesMatch